import { useTranslation } from 'react-i18next'
import { Table } from 'antd'
import Skeleton from 'react-loading-skeleton'

import FormatPrice from '@/components/FormatPrice'

const OrderDetailsCartSummary = ({
  cartSubTotal,
  cartTotal,
  shippingCosts,
  voucherValue,
  additionalCost,
  isLoading,
  vat,
  cartTotalVAT,
  currencyUnit,
  checkoutSettings,
  hideVoucher,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <Table.Summary.Row>
        <Table.Summary.Cell colSpan={5}>
          <span>{t('cart.table.subtotal')}</span>
        </Table.Summary.Cell>
        <Table.Summary.Cell>
          {isLoading
            ? <Skeleton />
            : <FormatPrice currencyUnit={currencyUnit} price={cartSubTotal} />}
        </Table.Summary.Cell>
      </Table.Summary.Row>
      <Table.Summary.Row>
        <Table.Summary.Cell colSpan={5}>
          <span>{t('cart.table.shippingCosts')}</span>
        </Table.Summary.Cell>
        <Table.Summary.Cell>
          {isLoading
            ? <Skeleton />
            : <FormatPrice currencyUnit={currencyUnit} price={shippingCosts} />}
        </Table.Summary.Cell>
      </Table.Summary.Row>
      {!!checkoutSettings?.headLvlConditions && (
        <Table.Summary.Row>
          <Table.Summary.Cell colSpan={5}>
            <span>{t('cart.table.additionalCost')}</span>
          </Table.Summary.Cell>
          <Table.Summary.Cell>
            {isLoading
              ? <Skeleton />
              : <FormatPrice currencyUnit={currencyUnit} price={additionalCost} />}
          </Table.Summary.Cell>
        </Table.Summary.Row>
      )}

      {!hideVoucher && voucherValue
        ? (
          <Table.Summary.Row>
            <Table.Summary.Cell colSpan={5}>
              <span>{t('voucher.fields.voucherCode')}</span>
            </Table.Summary.Cell>
            <Table.Summary.Cell>
              {isLoading ? <Skeleton /> : (
                <FormatPrice
                  currencyUnit={currencyUnit}
                  price={voucherValue?.totalDiscount}
                />
              )}
            </Table.Summary.Cell>
          </Table.Summary.Row>
        )
        : null}

      <Table.Summary.Row className="total-section">
        <Table.Summary.Cell colSpan={5}>
          <span>{t('total')}</span>
        </Table.Summary.Cell>
        <Table.Summary.Cell>
          {isLoading ? <Skeleton /> : <FormatPrice currencyUnit={currencyUnit} price={cartTotal} />}
        </Table.Summary.Cell>
      </Table.Summary.Row>

      {checkoutSettings?.includingVAT && (
        <>
          <Table.Summary.Row className="total-section vat">
            <Table.Summary.Cell colSpan={5}>
              <span>{t('vat')}</span>
            </Table.Summary.Cell>
            <Table.Summary.Cell>
              {isLoading ? <Skeleton /> : <FormatPrice currencyUnit={currencyUnit} price={vat} />}
            </Table.Summary.Cell>
          </Table.Summary.Row>

          <Table.Summary.Row className="total-section">
            <Table.Summary.Cell colSpan={5}>
              <span>{t('totalWithVat')}</span>
            </Table.Summary.Cell>
            <Table.Summary.Cell>
              {isLoading
                ? <Skeleton />
                : <FormatPrice currencyUnit={currencyUnit} price={cartTotalVAT} />}
            </Table.Summary.Cell>
          </Table.Summary.Row>
        </>
      )}
    </>
  )
}

export default OrderDetailsCartSummary
